import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { ContactGufDto} from 'openapi/build';
import { ContactGufItem } from 'src/app/shared/interfaces/contact-guf-item';

@Component({
  selector: 'mclu-contact-guf',
  templateUrl: './contact-guf.component.html',
  styleUrls: ['./contact-guf.component.scss'],
})
export class ContactGufComponent implements OnInit {


  @Input()
  public contactGufItem: ContactGufDto;

  @Input()
  public showLocaliser = false;

  @Output()
  public clickLocaliserEvent = new EventEmitter<ContactGufDto>();


  constructor(
  ) { }

  ngOnInit() {
  }

  public clickEvent() {
    this.clickLocaliserEvent.emit(this.contactGufItem);
  }
}
